export const WAITLIST_FTUE_POPUP_TOGGLE = 'WAITLIST_FTUE_POPUP_TOGGLE';

interface WaitlistFTUEPopupToggleAction {
    type: typeof WAITLIST_FTUE_POPUP_TOGGLE;
}

export type WaitlistActionTypes = WaitlistFTUEPopupToggleAction;
